export const SYNC_OPTIONS_MERGE = [
  {
    label: 'label.SYNC_OPTIONS_DO_NOT_MERGE_OR_REPLACE',
    value: null
  },
  {
    label: 'label.SYNC_OPTIONS_MERGE_AND_REPLACE',
    value: true
  },
  {
    label: 'label.SYNC_OPTIONS_MERGE_AND_DO_NOT_REPLACE',
    value: false
  }
];

export const SYNC_OPTIONS_NOSYNC = [
  {
    label: 'label.SYNC_OPTIONS_DO_NOT_OVERWRITE',
    value: false
  },
  {
    label: 'label.SYNC_OPTIONS_OVERWRITE',
    value: true
  }
];

export const SYNC_OPTIONS_FIELDS = [
  {
    label: 'label.SYNC_OPTIONS_FIELDS_UNLOCKED',
    value: false
  },
  {
    label: 'label.SYNC_OPTIONS_FIELDS_LOCKED',
    value: true
  }
];
